/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Cores {
  constructor () {
    this.cor_id = uuidV4()
    this.descr = ''
  }
}
